<template>
  <div>
    <div v-if="data.column.field === 'campaignName'" class="d-flex align-items-center">
      <span>{{ data.row.campaignName }}</span>
    </div>
    <div v-if="data.column.field === 'accountName'" class="d-flex align-items-center">
      <span>{{ data.row.accountName }}</span>
    </div>
    <div v-if="data.column.field === 'dailyBudget'" class="d-flex align-items-center">
      <span>{{ data.row.dailyBudget }}</span>
    </div>
    <div v-if="data.column.field === 'totalBudget'" class="d-flex align-items-center">
      <span>{{ data.row.totalBudget }}</span>
    </div>
    <div v-if="data.column.field === 'actionsCost'" class="d-flex align-items-center">
      <span>{{ data.row.actionsCost + $currencySymbol }}</span>
    </div>
    <div v-if="data.column.field === 'clicksCost'" class="d-flex align-items-center">
      <span>{{ data.row.clicksCost + $currencySymbol }}</span>
    </div>
    <div v-if="data.column.field === 'views'" class="d-flex align-items-center">
      <span>{{ data.row.views }}</span>
    </div>
    <div v-if="data.column.field === 'viewsCost'" class="d-flex align-items-center">
      <span>{{ data.row.viewsCost + $currencySymbol }}</span>
    </div>
    <div v-if="data.column.field === 'status'" class="d-flex align-items-center">
      <span>{{ data.row.status }}</span>
    </div>
    <div v-if="data.column.field === 'period'" class="d-flex align-items-center">
      <span>{{ data.row.period }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
</style>
